import Typography from '@sharedComponents/Typography';

import * as style from './style.module.css';

const Divider = ({ text = '', light = false }) => {
    return (
        <div className={`${style.divider} ${light ? style.light : ''}`}>
            {text && (
                <>
                    <hr />
                    <Typography fontSize="m" fontWeight="regular" div>
                        {text}
                    </Typography>
                </>
            )}
            <hr />
        </div>
    );
};

export default Divider;
